import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { SearchBarComponent } from 'src/app/common/components/search-bar/search-bar.component';
import {
  actionIdConstants,
  countryCode,
} from 'src/app/common/constants/common.contants';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { activityPayload } from 'src/app/common/models/userActivity.model';
import { SharedService } from 'src/app/common/services/shared.service';
import { UserService } from 'src/app/common/services/user.service';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';
import { ReportService } from 'src/app/reports/services/report.service';

@Component({
  selector: 'app-universal-search',
  templateUrl: './universal-search.component.html',
  styleUrls: ['./universal-search.component.scss'],
})
export class UniversalSearchComponent {
  private unsubscribe$: Subject<void> = new Subject<void>();
  @Input() Searched_properties: any;
  @Input() cityCode: string = '';

  @Output() SearchedParcelOnMap = new EventEmitter();
  @Output() closeChip = new EventEmitter();
  ReportsChartEnum = ReportsChartEnum;

  @ViewChild('searchpropertyDetail') searchpropertyDetail!: SearchBarComponent;

  public current_lang: any = 'en';
  showRecentSearch: boolean = true;
  searchedData: any = [];
  recentSearchedData: any[] = [];
  searchText: string = '';
  searchingLoader: boolean = false;
  isSaudiCheck: boolean = false;
  reportId: number = 0;

  constructor(
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    private reportService: ReportService,
    private userService: UserService
  ) {
    this.sharedService.language$
      .pipe(debounceTime(200), takeUntil(this.unsubscribe$))
      .subscribe((lang) => {
        this.current_lang = lang;
      });
  }

  ngOnInit() {
    this.isSaudiCheck =
      this.sharedService.getStoreValue(GlobalContants.StoreKey.countryCode) ===
      countryCode.saudi;
    this.getRecentSearchedParcelDetail();
    this.reportId = this.activatedRoute.snapshot.queryParams['rid'];
  }

  locateSearchedParcelOnMap(properties: any, recent:boolean=false) {
    this.addRecentSearchedParcelDetail(properties);

    let queryParams = { ...this.reportService.queryParams };
    let year = new Date().getFullYear();
    if (queryParams?.year) {
      year = this.reportService.yearMaxValue(queryParams.year);
    }

    this.userActivity({
            search_text: this.searchText ? this.searchText : null,
            year: year,
            selected_data: properties
          },recent);
    this.SearchedParcelOnMap.emit(properties);
  }

  clearChipdata(search: boolean = false) {
    this.searchpropertyDetail?.searchControl.patchValue('');
    this.closeChip.emit(search);
  }

  closeMapSearch(event: boolean) {
    if (event) {
      this.searchpropertyDetail?.searchControl.patchValue('');
    }
  }

  addRecentSearchedParcelDetail(propertyData: any, searchedText: string = '') {
    const projectName = propertyData.project_name ? ` (${propertyData.project_name})` : "";

    const payload = {
      property_uid: propertyData.property_uid ?? "",
      neigh_name: propertyData.neigh_name ?? "",
      block_name: propertyData.block_name ?? "",
      property_name: `${propertyData.property_name ?? ""}${projectName}`,
      search_text: this.searchpropertyDetail?.searchControl?.value ?? "",
    };
    this.reportService.addRecentSearchedParcelDetail(payload).subscribe({
      next: (res: any) => {
        if (res && res.status == 201) this.getRecentSearchedParcelDetail();
      },
      error: (err) => {},
    });
  }
  deleteRecentSearchedParcelDetail(action: string, id: number = 0) {
    this.reportService.deleteRecentSearchedParcelDetail(action, id).subscribe({
      next: (res: any) => {
        if (res && res.status == 201) this.getRecentSearchedParcelDetail();
      },
      error: (err: any) => {},
    });
  }

  /**
   * This fuction use for the getting recent search
   */
  getRecentSearchedParcelDetail() {
    this.reportService.getRecentSearchedParcelDetail().subscribe({
      next: (res: any) => {
        if (res && res.status == 200) this.recentSearchedData = res?.data;
        else {
          this.recentSearchedData = [];
        }
      },
      error: (err) => {
        this.recentSearchedData = [];
      },
    });
  }
  /**
   * This function is used to get the property detail based on universal search on map
   * @param searchedText : searched text used to get the filterd data based on user search.
   */
  getMapSearchedDetail(searchedText: string = '') {
    let queryParams = { ...this.reportService.queryParams };
    let year = new Date().getFullYear();
    if (queryParams?.year) {
      year = this.reportService.yearMaxValue(queryParams.year);
    }
    searchedText = searchedText.trim();
    this.searchText = searchedText;

    if (searchedText) this.showRecentSearch = false;
    else {
      this.showRecentSearch = true;
      return;
    }
  
    this.searchingLoader = true;
    this.reportService.getMapSearchedDetail(searchedText, year).subscribe({
      next: (res: any) => {
        this.searchingLoader = false;
        if (res?.status == 200) {
          this.searchedData = res.data;
          // Handle case where userInfo is null or undefined          
        } else {
          this.searchedData = [];
          this.userActivity({
            search_text: searchedText,
            year: year,
            search_result: null
          });
        }
      },
      error: (err: any) => {
        this.searchingLoader = false;
        //this.alertService.error(err)
      },
    });
  }

  userActivity(userdata={}, recent_search:boolean=false){
      const activity:activityPayload = {
      userdata: userdata,
      actionId: recent_search ? actionIdConstants.recent_search : actionIdConstants.universal_search,
      entity: 'report',
      entityId: this.reportId,
    };
    this.userService.logUserActivity(activity);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
